import styled, { createGlobalStyle } from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const ModalOverrides = createGlobalStyle`
  [data-slot="dialog-overlay"]:has(~ .modal-completion-onboarding-v3) {
    display: none !important;
  }

  [data-state="closed"] .modal-completion-onboarding-v3 {
    display: none !important;
  }

  .modal-completion-onboarding-v3 {
    padding: 0 !important;
    gap: 0 !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    margin: 0 !important;
    z-index: 9999 !important;

    @media (max-width: ${tokens.breakpoints.tablet}px) {
      position: fixed !important;
      inset: auto 0 0 0 !important;
      top: auto !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      transform: none !important;
      translate: none !important;
      width: 100% !important;
      max-width: 100% !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      max-height: none !important;
      height: auto !important;

      animation: none !important;
      transition: none !important;
    }

    @media (min-width: ${tokens.breakpoints.tablet + 1}px) {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      translate: none !important;
      width: auto !important;
      max-width: 600px !important;
      bottom: auto !important;
      right: auto !important;
    }

    [data-slot="dialog-close"] {
      display: none !important;
    }
  }
`

export const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(5, 59, 75, 0.6);
  z-index: 9996;
  pointer-events: none;
`

export const BackgroundImage = styled.img`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  object-position: center;
  z-index: 9997;
  pointer-events: none;
  opacity: 1;
  filter: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  display: block;
`

export const Container = styled.div`
  background: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  width: 600px;
  max-width: 100%;
  padding: 0;
  overflow: hidden;
  position: relative;
  padding-top: 144px;
  z-index: 9999;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    overflow: hidden;
    min-height: auto;
    position: relative;
  }
`

export const ForestIllustration = styled.div`
  width: 100%;
  height: 144px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  flex-shrink: 0;
  border-radius: 20px 20px 0 0;
  z-index: 1;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    position: relative;
    height: 200px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
  }
`

export const ForestImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  margin: 0;
  padding: 0;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  padding: 40px 32px 0 32px;
  position: relative;
  z-index: 2;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    padding: 24px 16px 0 16px;
  }
`

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 450px;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 100%;
  }
`

export const Title = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  color: #053b4b;
  text-align: center;
  margin: 0;
  width: 100%;
`

export const Subtitle = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  color: #406a76;
  text-align: center;
  margin: 0;
  width: 100%;
  padding-bottom: 25px;
`

export const RewardContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 16px;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: row;
    gap: 24px;
    justify-content: center;
  }
`

export const RewardCard = styled.div`
  background: #f1f7fc;
  border-radius: 8px;
  padding: 36px 0 18px 0;
  width: 144px;
  height: 67px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
  position: relative;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: column;
    gap: 8px;
  }
`

export const CoinIcon = styled.img`
  width: 54px;
  height: 54px;
  object-fit: contain;
  position: absolute;
  top: -27px;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 60px;
    height: 60px;
  }
`

export const RewardText = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 2;
  color: #053b4b;
  margin: 0;
  text-align: center;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    text-align: center;
    font-size: 16px;
  }
`

export const RewardValue = styled.span`
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #053b4b;
`

export const Description = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: #406a76;
  text-align: center;
  margin: 0;
  margin-top: 16px;
  width: 100%;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 24px 32px 32px 32px;
  position: relative;
  z-index: 2;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: row;
    padding: 24px 16px 32px 16px;
    gap: 12px;
  }
`

export const SecondaryButton = styled.button`
  background: white;
  border: 1px solid #b7c7cb;
  border-radius: 10px;
  padding: 12px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: #406a76;
  text-align: center;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f1f7fc;
    border-color: #406a76;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 20%;
    flex: 1;
    padding: 12px 8px;
    font-size: 14px;
    min-height: 44px;
  }
`

export const PrimaryButton = styled.button`
  background: #45d0c1;
  border: 1px solid #45d0c1;
  border-radius: 10px;
  padding: 12px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: black;
  text-align: center;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #3abfb0;
    border-color: #3abfb0;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    width: 80%;
    flex: 1;
    padding: 12px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 24px;
    height: 24px;
    color: #406a76;
  }
`
